// src/redux/slices/authSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { encryptToken } from '../../Utlis/Encryption';

const storedEncryptedToken = localStorage.getItem("token");
const storedUser = localStorage.getItem("user");
const storedInviteProfileUpdateToken = localStorage.getItem("inviteProfileUpdateToken");

const initialState = {
  token: storedEncryptedToken || null,
   user: storedUser ? JSON.parse(storedUser) : null,
   otpData: null, 
               inviteEmail: null,

     resetToken: null, 
       profileUpdateToken: null, 
  inviteProfileUpdateToken: storedInviteProfileUpdateToken || null, // invite flow

};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      const { token, user } = action.payload;
      const encryptedToken = encryptToken(token);
      state.token = encryptedToken;
      state.user = user;
        console.log("📦 [authSlice] setCredentials triggered");
  console.log("🔐 Encrypted Token stored:", encryptedToken);
  console.log("👤 User stored:", user);
      console.log("Encrypted token before storing:", encryptedToken);
      localStorage.setItem("token", encryptedToken);
      localStorage.setItem("token", encryptedToken);
      localStorage.setItem("user", JSON.stringify(user));
    },
      setOtpData: (state, action) => {
      state.otpData = action.payload; // 👈 email and otp
    },
       setResetToken: (state, action) => {
      state.resetToken = action.payload; // ✅ Set the token
    },
        setProfileUpdateToken: (state, action) => {
      state.profileUpdateToken = action.payload;
    },
         setInviteProfileUpdateToken: (state, action) => {
      state.inviteProfileUpdateToken = action.payload;
      localStorage.setItem("inviteProfileUpdateToken", action.payload);
    },
          setInviteEmail: (state, action) => {   // ✅ new reducer
      state.inviteEmail = action.payload;
    },
    clearInviteFlow: (state) => {
      state.inviteProfileUpdateToken = null;
      state.inviteEmail = null;
      state.profileUpdateToken = null;
      localStorage.removeItem("inviteProfileUpdateToken");
      localStorage.removeItem("profileUpdateToken");
      localStorage.removeItem("inviteEmail");
    },
    logout: (state) => {
      state.token = null;
      state.user = null;
       state.otpData = null;
        state.profileUpdateToken = null;
                          state.inviteEmail = null;
      localStorage.removeItem("token");
        localStorage.removeItem("profileUpdateToken");
  localStorage.removeItem("inviteProfileUpdateToken");
  localStorage.removeItem("inviteEmail");
    }
  },
});

export const { setCredentials, logout , setOtpData, setResetToken ,setProfileUpdateToken, setInviteEmail,
     setInviteProfileUpdateToken, clearInviteFlow,
 } = authSlice.actions;
export default authSlice.reducer;



// import { createSlice } from '@reduxjs/toolkit';
// import { encryptToken } from '../../Utlis/Encryption';

// // 🧠 Retrieve stored data from localStorage
// const storedEncryptedToken = localStorage.getItem("token");
// const storedUser = localStorage.getItem("user");

// // 🏁 Initialize Redux state
// const initialState = {
//   token: storedEncryptedToken || null,
//   user: storedUser ? JSON.parse(storedUser) : null,
//   otpData: null,
//   resetToken: null,
// };

// const authSlice = createSlice({
//   name: 'auth',
//   initialState,
//   reducers: {
//     // ✅ Called after successful login
//     setCredentials: (state, action) => {
//       const { token, user } = action.payload;
//       const encryptedToken = encryptToken(token);
//       state.token = encryptedToken;
//       state.user = user;

//       // 🗂️ Store in localStorage
//       localStorage.setItem("token", encryptedToken);
//       localStorage.setItem("user", JSON.stringify(user));

//       console.log("📦 [authSlice] setCredentials triggered");
//       console.log("🔐 Encrypted Token stored:", encryptedToken);
//       console.log("👤 User stored:", user);
//     },

//     // 📩 For OTP flow
//     setOtpData: (state, action) => {
//       state.otpData = action.payload;
//     },

//     // 🔑 After reset-password request
//     setResetToken: (state, action) => {
//       state.resetToken = action.payload;
//     },

//     // 🚪 Log user out and clear storage
//     logout: (state) => {
//       state.token = null;
//       state.user = null;
//       state.otpData = null;
//       state.resetToken = null;

//       // 🧹 Clear localStorage
//       localStorage.removeItem("token");
//       localStorage.removeItem("user");

//       console.log("👋 Logged out and cleared storage.");
//     }
//   },
// });

// export const { setCredentials, logout, setOtpData, setResetToken } = authSlice.actions;
// export default authSlice.reducer;
